import moment from "moment";
import React, { forwardRef } from "react";
import ReactDatePicker from "react-datepicker";
import { twMerge } from "tailwind-merge";
import { useMask } from "@react-input/mask";
import Input from "components/input";
import { CalendarIcon } from "@heroicons/react/outline";

type InputProps = {
  placeholder?: string;
  id?: string;
  label?: string;
  error?: any;
  type?: string;
  [x: string]: any;
};

const CustomInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const inputRef = useMask({
    mask: "__:__",
    replacement: { _: /\d/ },
  });
  return (
    <div className="relative">
      <Input type="text" ref={inputRef} {...props} />
      <CalendarIcon className="size-4 absolute top-1/2 right-4 -translate-y-1/2 select-none" />
    </div>
  )
})

const TimePicker = React.forwardRef((props: InputProps, ref: any) => {
  const selectedDateString = moment.utc(props.value, "HH:mm").format("YYYY-MM-DD HH:mm");

  return (
    <ReactDatePicker 
      selected={props.value ? moment(selectedDateString).toDate() : null}
      onChange={props.onChange}
      wrapperClassName="w-full"
      placeholderText={props.placeholder ? `${props.placeholder} (HH:mm)` : "HH:mm"}
      dateFormat="HH:mm"
      className={twMerge(
        `input ${
          props.error
            ? "border-red-600 focus:border-red-600"
            : "border-gray-300 focus:border-brand-500"
        }`,
        props.className
      )}
      ref={ref}
      showTimeSelectOnly
      customInput={(<CustomInput onChange={props.onChange} />)}
      maxDate={props.maxDate ?? null}
      showPopperArrow={false}
    />
  )
});

TimePicker.displayName = "TimePicker";

export default TimePicker;
